import {BaseEntity, IConstructor} from "../entities/BaseEntity";
import {HttpHandlerService} from "./HttpHandlerService";
import {IService} from "./IService";
import { StateService } from "@uirouter/angularjs";

export class BaseService<T extends BaseEntity> extends HttpHandlerService implements IService{

    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService, public ctor:IConstructor<T>) {
        super($http, $q, $state);
    }

    private parseArray(jsonArr:any):T[]{
        var arr:T[] = [];
        for(var i:number = 0; i<jsonArr.length; i++){
            var t:T = new this.ctor();
            t.parseJson(jsonArr[i]);
            arr.push(t);
        }
        return arr;
    }

    useBaseGetHandler(route:string, action:string, params:any):ng.IPromise< T > {
        return this.useGetHandler(route,action,params)
            .then(
                (data:any):ng.IPromise< any > => {
                    if(data == null)
                        return this.$q.when<T>(null);
                    else {
                        var t: T = new this.ctor();
                        t.parseJson(data);
                        return this.$q.when<T>(t);
                    }
                }
            );
    }

    useBaseGetArrayHandler(route:string, action:string, params:any):ng.IPromise< T[] > {
        return this.useGetHandler(route,action,params)
            .then(
                (data:any):ng.IPromise< any > => {
                    if(data == null)
                        return this.$q.when<T[]>([]);
                    else
                        return this.$q.when<T[]>(this.parseArray(data));
                }
            );
    }

    getPaged(search:string,page:number,pageSize:number,orderColumn:string,orderDirection:string):ng.IPromise< T[] > {
        var config:any = {};
        var aoeuoeu = new this.ctor();
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"Paged?search="+this.formatStr(search)+"&page="+page+"&pageSize="+
            pageSize+"&orderColumn="+this.formatStr(orderColumn)+"&orderDirection="+this.formatStr(orderDirection), config);
    }

    getCount(search:string=""):ng.IPromise< number > {
        var config:any = {};
        return this.useGetHandler(this.getBasesUrl(),"Count?search="+this.formatStr(search), config);
    }

    getAll(search:string="",orderColumn:string="",orderDirection:string=""):ng.IPromise<T[]> {
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"?search="+search+"&orderColumn="+orderColumn+"&orderDirection="+orderDirection, config);
    }

    get(id:number):ng.IPromise<T> {
        var config:any = {};
        return this.useBaseGetHandler(this.getBaseUrl(),""+id, config);
    }
    getMostRecent():ng.IPromise<T> {
        var config:any = {};
        return this.useBaseGetHandler(this.getBaseUrl(),"MostRecent", config);
    }

    insert(entity:T):ng.IPromise<number>{
        return this.usePostHandler(this.getBaseUrl(),"", entity).then((data)=>{
            return this.$q.when(data)
        });
    }

    inserts(entities:T[]):ng.IPromise<number>{
        return this.usePostHandler(this.getBasesUrl(),"", entities).then((data)=>{
            return this.$q.when(data)
        });
    }
    update(entity:T):ng.IPromise<boolean>{
        return this.usePutHandler(this.getBaseUrl(),"", entity).then((data)=>{
            return this.$q.when(true)
        });
    }

    updates(entities:T[]):ng.IPromise<number>{
        return this.usePutHandler(this.getBasesUrl(),"", entities).then((data)=>{
            return this.$q.when(data)
        });
    }
    delete(ids:number[]):ng.IPromise<boolean>{
        if(ids == null || ids.length == 0)
            return this.$q.when<boolean>(true);
        var action = "?ids="+ids[0];
        for(var i=1; i<ids.length; i++){
            action = action + "&ids="+ids[i];
        }
        return this.useDeleteHandler(this.getBasesUrl(),action, null).then((data)=>{
            return this.$q.when(true);
        });
    }
}
